import React from 'react';
import PropTypes from 'prop-types';

import { DateLabel, HourLabel } from '..';

const DateHourLabel = ( {date} ) => (
    <>
        <DateLabel date={date} />
        {' '}
        <HourLabel date={date} />
    </>
);
export default DateHourLabel;

DateHourLabel.propTypes = {
    date: PropTypes.instanceOf(Date).isRequired,
}